import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject, Subject, timer, ReplaySubject} from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpServiceHelper } from 'src/app/types/common/HttpServiceHelper';
import { CryptUtilService } from './crypt-util.service';
import { take } from 'rxjs/operators';
import { SpinnerComponent } from '@projects/workspace/src/app/my-projects/spinner/spinner.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BaseService } from '@projects/shared-lib/src/public-api';
import { saveAs } from 'file-saver';
import { User } from '../constants/ascend-user-info';
import { ActivitiesGlobalContextService } from '@projects/trainstops/src/app/feature/activities/activities-global-context.service';
import { REPORT_GENERATION_STATUS, REPORT_STATUS_TYPE } from '../constants/common-dialogue-box';
import { IConversionRequestBody } from '@projects/psg/src/app/psg/file-upload-drag-drop/interfaces/file-upload-drag-drop.interface';
import { IRefineTaxonomyPayload } from '@projects/trainstops/src/app/shared/interfaces/refine-taxonomy-process.interface';
import { IUpdateCrossRegionLanguagePayload } from '../interfaces/navigation-bar.interface';

export interface userData {
	first_name: string,
	last_name: string,
	user_name: string,
	email_id: string,
	designation: string,
	job_title: string
}

@Injectable({
	providedIn: 'root',
})
export class SharedService {
	private searchLinkURL: string = `${environment.BASE_URL}/searchlinks`;
	private currentTabIndex = new BehaviorSubject<number>(0);
	private jiraProjectInfo = new BehaviorSubject<{ instanceId: number , key: string; }>({ instanceId: 0,  key: '' });
	public tabIndexShare = this.currentTabIndex.asObservable();
	public aboutScreen = new Subject();
	private bgColor = new BehaviorSubject<string>("");
	public bgColorShare = this.bgColor.asObservable();
	private redirectToPsg: BehaviorSubject<boolean>;
	private genAIEnabled: BehaviorSubject<boolean>;
  public retryTool: BehaviorSubject<string> = new BehaviorSubject('');
	public tabCountEvent = new EventEmitter();
	public defineRoadmapSprintPlan = new EventEmitter();
	public dataChangeEvent = new EventEmitter();
	public toggled: string = '';
	public currentTab: string = '';
	filterSelected: boolean = false;
	public IsImportedSelected: boolean = false;
	public IsFailedSelected: boolean = false;
	public activitySelectedFn: any;
	public UserPermissionData: any;
	public selectedPackage: any = this.cryptUtilService.getItem('SELECTED_PACKAGE', 'SESSION') ? this.cryptUtilService.getItem('SELECTED_PACKAGE', 'SESSION') : undefined;
	public isSitemapPackageReset: boolean = false;
	public languageFlag: BehaviorSubject<number>;
	public currentLangId: BehaviorSubject<number>;
	public userRoleData :any;
	public activeFlags: BehaviorSubject<any>;
	private userRoleChange = new ReplaySubject<boolean>(1);
  userRoleChange$ = this.userRoleChange.asObservable();
	private roleChangeMessage = new BehaviorSubject<string>('');
  roleChangeMessage$ = this.roleChangeMessage.asObservable();
	publishBgColor(color) {
		this.bgColor.next(color);
	}

	public docAddEvent = new EventEmitter();
	public toggledEvent = new EventEmitter();
	public selectedPageEvent = new EventEmitter();
	public selectedTabEvent = new EventEmitter();
	public summaryFilterEvent = new EventEmitter();
	public getDataEvent = new EventEmitter();
	public getDataEventAlm = new EventEmitter();
	public userData: BehaviorSubject<any> = new BehaviorSubject<userData>(null);

	options: any[] = [
		{
			value: 'Leading Practices',
			route: '/imagine/architect/Leading Practices',
			tab: 'Leading Practices',
			L0: '',
			L1: '',
			L2: '',
			industry: '',
			sector: '',
			region: '',
			persona: ''
		},
		{
			value: 'Userstories',
			route: '/imagine/architect/Userstories',
			tab: 'Userstories',
			L0: '',
			L1: '',
			L2: '',
			industry: '',
			sector: '',
			region: '',
			persona: ''
		},
		{
			value: 'Business Processes',
			route: '/imagine/architect/Business Processes',
			tab: 'Business Processes',
			L0: '',
			L1: '',
			L2: '',
			industry: '',
			sector: '',
			region: '',
			persona: ''
		},
		{
			value: 'ERP Configurations',
			route: '/imagine/architect/ERP Configurations',
			tab: 'ERP Configurations',
			L0: '',
			L1: '',
			L2: '',
			industry: '',
			sector: '',
			region: '',
			persona: ''
		}
	];

	public updateTaxonomySuccessful: BehaviorSubject<boolean>;
	public disableDefineRoadmapBtn: BehaviorSubject<boolean>;
	public disableSprintPlanSaveBtn: BehaviorSubject<boolean>;
	public disableSprintPlanApplyAllTracksBtn: BehaviorSubject<boolean>;
	public disableSprintPlanResetBtn: BehaviorSubject<boolean>;
	public disableGenerateSprintBtn: BehaviorSubject<boolean>;
	public disableConfirmAllGenerateSprintBtn: BehaviorSubject<boolean>;
	public disableFinalizeSprintEditIcon: BehaviorSubject<Object>;
	public disableFinalizeSprintSaveBtn: BehaviorSubject<boolean>;
	public disableFinalizeSprintConsolidateBtn: BehaviorSubject<boolean>;
	public disableFinalizeSprintConfirmBtn: BehaviorSubject<boolean>;
	public enablePrioritizeUSViewMode: BehaviorSubject<boolean>;
	public enablGenerateSprintViewMode: BehaviorSubject<boolean>;
	public enableFinalizeSprintViewMode: BehaviorSubject<boolean>;
	public isFinalizeSprintConfirmAll: BehaviorSubject<boolean>;
	public isFinalizeSprintConfirmL1: BehaviorSubject<String>;
	public userPermissionDataUpdated: BehaviorSubject<boolean>;
	public hideNavigationBar: BehaviorSubject<boolean>;
	public isExternalSignupCompleted: BehaviorSubject<boolean>;
	public userRelatedAPI$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	public isFeatureFlagUpdated: BehaviorSubject<boolean>;
	public isFinalizeSprintPageDirty = false;
	public defineRoadmapData = [];
	private generateSprintData = [];
	private _finalizeSprintPayload = [];
	private _generateSprintPayload = {
		assignedSprints: {
			sprintCapacities: [],
			children: []
		}
	};
	private finalizeSprintMasterData = [];
	private dialogRef;
	private reportPollingTimer;
	private reportRequestId;
	private reportRequestPayload;
	private packageContentMicroservice: string;
	private languageChangeSubject = new Subject<void>();

	languageChange$ = this.languageChangeSubject.asObservable();

	constructor(
    private http: HttpClient,
    private baseService: BaseService,
    private httpService: HttpServiceHelper,
    public cryptUtilService: CryptUtilService,
    public dialog: MatDialog,
    private globalContext: ActivitiesGlobalContextService,
	) {
		this.updateTaxonomySuccessful = new BehaviorSubject(false);
		this.disableDefineRoadmapBtn = new BehaviorSubject(false);
		this.disableSprintPlanSaveBtn = new BehaviorSubject(false);
		this.disableSprintPlanResetBtn = new BehaviorSubject(false);
		this.disableSprintPlanApplyAllTracksBtn = new BehaviorSubject(false);
		this.disableGenerateSprintBtn = new BehaviorSubject(true);
		this.disableConfirmAllGenerateSprintBtn = new BehaviorSubject(false);
		this.disableFinalizeSprintEditIcon = new BehaviorSubject(false);
		this.disableFinalizeSprintSaveBtn = new BehaviorSubject(false);
		this.disableFinalizeSprintConsolidateBtn = new BehaviorSubject(true);
		this.disableFinalizeSprintConfirmBtn = new BehaviorSubject(true);
		this.enablePrioritizeUSViewMode = new BehaviorSubject(true);
		this.enablGenerateSprintViewMode = new BehaviorSubject(true);
		this.enableFinalizeSprintViewMode = new BehaviorSubject(true);
		this.isFinalizeSprintConfirmAll = new BehaviorSubject(null);
		this.userPermissionDataUpdated = new BehaviorSubject(false);
		this.hideNavigationBar = new BehaviorSubject(false);
		this.isExternalSignupCompleted = new BehaviorSubject(null);
		this.isFeatureFlagUpdated = new BehaviorSubject(false);
		this.redirectToPsg = new BehaviorSubject(false);
		this.genAIEnabled = new BehaviorSubject(false);
		this.languageFlag = new BehaviorSubject(null);
		this.currentLangId = new BehaviorSubject(null);
		this.packageContentMicroservice = environment.API_MICROSERVICE_URL.REPORTING;
		this.activeFlags = new BehaviorSubject(false);
	}

  /**
   * Get HTML content from backend
   */
  getLicenseDocumentUrl(fileName: string): Observable<string> {
    const url = `${environment.API_MICROSERVICE_URL.ADMIN}/admin/get-attribution-report-content?fileName=${fileName}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...(environment.isLocal) && {"Authorization": "Bearer " + localStorage.getItem('auth-token')}
    });

    return this.http.get(url, {
      headers,
      responseType: 'text'
    });
  }

	getTabs(): Observable<any[]> {
		//  return of(this.options);
		return this.http.get<any>(this.searchLinkURL);
	}

	setGenAIEnabled(value: boolean): void {
		this.genAIEnabled.next(value);
	}

	getGenAIEnabled() {
		return this.genAIEnabled.asObservable();
	}

	getIndex(tabs, URL) {
		URL = decodeURI(URL);
		URL = URL.charAt(0) == '/' ? URL.substr(1) : URL
		let currentTab = tabs.find(t => t.route == URL)
		if (currentTab) {
			this.currentTabIndex.next(currentTab.tab);
		}
	}

	getPackagePref(package_id: number, function_id: number, feature_id: number, langId) {
		return this.http.get(`${environment.API_MICROSERVICE_URL.ADMIN}/package/preferences/${package_id}/${function_id}/${feature_id}?languageId=${langId}`);
	}

	getFeaturesData(id: any) {
		return this.http.get(environment.API_MICROSERVICE_URL?.ADMIN + '/package/features/0');
	}

	getData(URL): Observable<any[]> {
		return this.http.get<any>(URL);
	}

	postData(URL, body): Observable<any> {
		return this.http.post<any>(URL, body);
	}

	getUserData(): Observable<any> {
		return this.userData.asObservable();
	}

	setUserData(data: userData) {
		this.userData.next(data);
	}

	saveUserData(userData) {
		return this.http.post<any>(`${environment.API_MICROSERVICE_URL?.USER}/user/add`, userData);
	}

  getRetryTool() {
	return this.retryTool.asObservable();
  }

  setRetryTool(toolTitle: string) {
	this.retryTool.next(toolTitle);
  }

	getADUser(emailId): Observable<User> {
		// Security Fix: Use $batch API (POST) to keep PII in request body instead of URL
		const batchRequest = {
			requests: [{
				id: '1',
				method: 'GET',
				url: `/users?$filter=((startswith(displayName,'${emailId}') or startswith(mail,'${emailId}')))`
			}]
		};
		return this.http.post('https://graph.microsoft.com/v1.0/$batch', batchRequest)
			.map(res => {
				const obj = (res as any).responses?.[0]?.body?.value?.[0];
				const userObject: userData = {
					first_name: obj.givenName,
					last_name: obj.surname,
					user_name: obj.displayName,
					email_id: obj.mail,
					designation: 'SOFTWARE ENGINEER',
					job_title: obj.jobTitle
				}
				this.setUserData(userObject);
				const user: User = new User();
				let email = obj.mail;

				if (email) {
					user.userId = obj.mail;
					user.userName = obj.displayName;
					user.ssoUser = obj;
				}
				return user;
			})
	}

	checkDataForDownload(url: string) {
		return this.http.get<any>(url);
	}

	checkDataForDownloadStories(url: string) {
		return this.http.get<any>(url);
	}
	checkDataForDownloadSprintStories(url: string) {
		return this.http.get<any>(url);
	}
	checkDataForDownloadValidStories(url: string) {
		return this.http.get<any>(url);
	}
	checkDataForJiraInstance(projectId: String, params?: any): any {
		return this.http.get<any>(`${this.baseService.BASE_URL}/project/${projectId}`, { params });
	}

	setUploadTaxanomyStatus(success: boolean) {
		this.updateTaxonomySuccessful.next(success);
	}

	checkSequenceNumber(tabCode: string) {
		const params = new HttpParams()
			.set('tab_code', tabCode);
		return this.http.get(environment.BASE_URL + "/architect/getSequenceNumberByTabCode", { params });
	}

	isSprintPlanIdAvailable(tabData, tabName?) {
		if (tabData) {
			if (tabName) {
				this.defineRoadmapData = [];
				this.defineRoadmapData = tabData;
			}
			for (let i = 0; i < tabData.length; i++) {
				if (tabData[i] && tabData[i].sprint_plan) {
					let sprintArr = tabData[i].sprint_plan[0].sprint_plan_id;
					if (!sprintArr) {
						this.disableDefineRoadmapBtn.next(true);
						break;
					} else {
						this.disableDefineRoadmapBtn.next(false);
					}
				}
			}
		}
	}

	updateDefineRoadmapData(defineRoadmapL1Data) {
		for (let i = 0; i < this.defineRoadmapData.length; i++) {
			let obj = this.defineRoadmapData[i];
			if (obj.l1 == defineRoadmapL1Data.l1) {
				obj.sprint_plan = defineRoadmapL1Data.sprint_plan;
			}
		}
		this.isSprintPlanIdAvailable(this.defineRoadmapData);
	}

	setProvisionTool(id, tool) {
		return this.http.post<any>(`${environment.API_BASE_URL}/tools/imagine/launchjourney/provisiontools/${id}/${tool[0].entityName}`, tool);
	}

	setProvisionToolForAutoOnOffBoard(projectId, tool, isMasterProject: boolean = false) {
		const apiUrl = isMasterProject 
			? environment.API_MICROSERVICE_URL.VERSION.V2.PROJECT
			: environment.API_MICROSERVICE_URL.PROJECT;
		return this.http.post<any>(`${apiUrl}/project/saveAutoOnOffBoardToolData/${projectId}`, tool);
	}

	setProvisionApp(id, app) {
		return this.http.post<any>(`${environment.API_BASE_URL}/tools/dfte/projectProvisioning/${id}`, app);
	}
	getJiraProjectInfo() {
	 return this.jiraProjectInfo.asObservable();
	}

	setJiraProjectInfo(instanceId: number , key: string, ) {
	this.jiraProjectInfo.next({instanceId , key });
	 }

	setProvisionUser(id, app) {
		return this.http.post<any>(`${environment.BASE_URL}/dfteUserProvision/${id}`, app);
	}
	setSmartForceProvisionUser(id, app) {
		return this.http.post<any>(`${environment.BASE_URL}/smartforceUserProvision/${id}`, app);
	}
	setSmartForceProvisionApp(id, app) {
		return this.http.post<any>(`${environment.API_BASE_URL}/tools/dfte/projectProvisioning/${id}`, app);
	}

	checkDataForALMInstance(projectId: String): any {
		return this.http.get<any>(`${environment.API_MICROSERVICE_URL?.PROJECT}/tools/dfteTools/${projectId}`);
	}

	confirmDefineRoadmapStep2(projectId, isJiraProject, queryParams) {
		return this.http.put<any>(`${environment.API_BASE_URL}/imagin/refineuserstories/sprints/confirm/${projectId}/${isJiraProject}?${queryParams}`, {});
	}

	resetDefineRoadmapStep2(projectId, bodyParams) {
		return this.http.post<any>(`${environment.API_BASE_URL}/imagin/refineuserstories/sprints/reset/${projectId}`, bodyParams);
	}

	saveDefineRoadmapStep2(functionPackageURL, activityId, projectUniqueId, projectId, isJiraProject, bodyParams) {
		return this.http.post<any>(`${environment.API_BASE_URL}/imagin/refineuserstories/sprints/save${functionPackageURL}/${activityId}/${projectUniqueId}/${projectId}/${isJiraProject}`, bodyParams);
	}

	saveAllDefineRoadmapStep2(functionPackageURL, activityId, projectUniqueId, projectId, isJiraProject, bodyParams) {
		return this.http.post<any>(`${environment.API_BASE_URL}/imagin/refineuserstories/sprints/saveAll${functionPackageURL}/${activityId}/${projectUniqueId}/${projectId}/${isJiraProject}`, bodyParams);
	}

	confirmAllDefineRoadmapStep2(functionPackageURL, activityId, projectUniqueId, projectId, isJiraProject, bodyParams) {
		return this.http.post<any>(`${environment.API_BASE_URL}/imagin/refineuserstories/sprints/confirmAll${functionPackageURL}/${activityId}/${projectUniqueId}/${projectId}/${isJiraProject}`, bodyParams);
	}

	checkDataForConfirmAllPrioritizeUS(url, requiredTabData) {
		if (requiredTabData) {
			return this.http.post<any>(url, requiredTabData);
		}
	}

	isGenerateSprintAllL3Confirmed(tabData, tabName?) {
		if (tabData) {
			if (tabName) {
				this.generateSprintData = [];
				this.generateSprintData = tabData;
			}
			for (let i = 0; i < tabData.length; i++) {
				if (!tabData?.[i].isconfirm_sprint_us_allocation) {
					this.disableConfirmAllGenerateSprintBtn.next(false);
					break;
				} else {
					this.disableConfirmAllGenerateSprintBtn.next(true);
				}
			}
		}
	}

	isGenerateSprintAnyL3Confirmed(tabData, tabName?) {
		if (tabData) {
			if (tabName) {
				this.generateSprintData = [];
				this.generateSprintData = tabData;
			}
			for (let i = 0; i < tabData.length; i++) {
				if (tabData?.[i].isconfirm_sprint_us_allocation) {
					this.disableGenerateSprintBtn.next(false);
					break;
				} else {
					this.disableGenerateSprintBtn.next(true);
				}
			}
		}
	}

	updateGenerateSprintData(l1_value) {
		if (l1_value) {
			for (let i = 0; i < this.generateSprintData.length; i++) {
				let obj = this.generateSprintData[i];
				if (obj.l1_value == l1_value) {
					obj['isconfirm_sprint_us_allocation'] = true;
				}
			}
			this.isGenerateSprintAllL3Confirmed(this.generateSprintData)
			this.isGenerateSprintAnyL3Confirmed(this.generateSprintData)

		}
	}

	updateConfirmFlagGenerateSprintData() {
		for (let i = 0; i < this.generateSprintData.length; i++) {
			let obj = this.generateSprintData[i];
			obj['isconfirm_sprint_us_allocation'] = true;
		}
		this.isGenerateSprintAllL3Confirmed(this.generateSprintData)
		this.isGenerateSprintAnyL3Confirmed(this.generateSprintData)
	}

	getSiteMapData(projectId: String, packageId, functionId) {
		return this.http.get<any>(`${environment.API_MICROSERVICE_URL.PROJECT}/sitemap-details/${projectId}?packageId=${packageId}&functionId=${functionId}`);

	}
	checkjiraexport(projectId: String): Observable<boolean> {
		return this.http.get<boolean>(`${environment.API_BASE_URL}/deliver/isexportedtojira/${projectId}`);
	}

	saveDefineRoadmapStep3(projectId, bodyParams) {
		return this.http.post<any>(`${environment.BASE_URL}/refineuserstories/finalizesprints/save/${projectId}`, bodyParams);
	}
	confirmpollingDefineRoadmapStep3(projectId, bodyParams) {
		return this.http.post<any>(`${environment.API_BASE_URL}/process/start/TargetSprintMapping?projectid=${projectId}`, bodyParams);
	}
	getDFTEUsersData(projectId): Observable<any> {
		return this.http.get<any>(`${environment.BASE_URL}/projectDfteUsers/${projectId}`);
	}

	getDFTEAppsData(projectId): Observable<any> {
		return this.http.get<any>(`${environment.BASE_URL}/dfte/digitalaccelerators/${projectId}/3`);
	}
	getSmartForceUsersData(projectId): Observable<any> {
		return this.http.get<any>(`${environment.BASE_URL}/projectSmartforceUsers/${projectId}`);
	}

	getSmartForceAppsData(projectId): Observable<any> {
		return this.http.get<any>(`${environment.BASE_URL}/smartforce/amplifiers/${projectId}/4`);
	}

	confirmDefineRoadmapStep3(projectId, bodyParams) {
		return this.http.post<any>(`${environment.BASE_URL}/refineuserstories/sprints/generateinjira/${projectId}`, bodyParams);
	}
	updateProvisionDetails(projectId, tool, bodyParams) {
		return this.http.post<any>(`${environment.BASE_URL}/imagine/launchjourney/updateprovisiondetails/${projectId}/${tool}`, bodyParams);
	}

	imaginecheckjiraexport(projectId: String): Observable<boolean> {
		return this.http.get<boolean>(`${environment.BASE_URL}/imagine/isexportedtojira/${projectId}`);
	}

	public get finalizeSprintPayload() {
		return this._finalizeSprintPayload;
	}
	public set finalizeSprintPayload(value) {
		this._finalizeSprintPayload = value;
	}

	public get generateSprintPayload() {
		return this._generateSprintPayload;
	}
	public set generateSprintPayload(value) {
		this._generateSprintPayload = value;
	}
	public checkIfAllUsAreRefined(l2_group) {
		let flag = true;
		l2_group.forEach((l2, index) => {
			l2.l3_group.forEach(l3 => {
				l3.l4_group.forEach(l4 => {
					if (l4.status == 'Unrefined') {
						flag = false
					}
				});
			});
		});
		return flag;
	}

	public getfinalizeSprintMasterData() {
		return this.finalizeSprintMasterData;
	}

	public setfinalizeSprintMasterData(value, l1?) {
		if (l1) {
			this.finalizeSprintMasterData.forEach((a) => {
				if (a && a.l1_tab === l1) {
					a.tabContent[0].sprint = [];
					a.tabContent[0].sprint = value.sprint;
				}
			});
		} else {
			let result = [];
			if (value.length) {
				result = result.concat(value);
			}
			this.finalizeSprintMasterData = JSON.parse(JSON.stringify(result));
		}
		console.log(this.finalizeSprintMasterData, l1);
	}

	public confirmL1finalizeSprintMasterData(l1?) {
		if (l1) {
			for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
				if (this.finalizeSprintMasterData[i]?.l1_tab == l1) {
					for (let j = 0; j < this.finalizeSprintMasterData[i]?.tabContent?.[0].sprint.length; j++) {
						this.finalizeSprintMasterData[i].tabContent[0].sprint[j].isSprintsFinalizeForJira = true;
					}
				}
			}
		}
	}

	public isAlll1ConfirmfinalizeSprintMasterData() {
		let isAllConfirmFlag = true;
		for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
			if (!this.finalizeSprintMasterData[i].tabContent?.[0].sprint?.[0].isSprintsFinalizeForJira) {
				isAllConfirmFlag = false;
			}
		}

		return isAllConfirmFlag;
	}

	public isMoreThanOneL1RemainToConfirmfinalizeSprintMasterData() {
		let isMoreThanOneL1RemainToConfirmFlag = false;
		let confirmCount = 0;
		for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
			if (this.finalizeSprintMasterData[i].tabContent?.[0].sprint?.[0].isSprintsFinalizeForJira) {
				confirmCount++;
			}
		}

		if ((this.finalizeSprintMasterData.length - confirmCount) > 1) {
			isMoreThanOneL1RemainToConfirmFlag = true;
		}
		return isMoreThanOneL1RemainToConfirmFlag;
	}

	public setUnsavedFlagfinalizeSprintMasterData(flag, l1?) {
		if (l1) {
			for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
				if (this.finalizeSprintMasterData[i].l1_tab == l1) {
					this.finalizeSprintMasterData[i].isFinalizeSprintPageDirty = flag;
				}
			}
		}
		else {
			for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
				this.finalizeSprintMasterData[i].isFinalizeSprintPageDirty = flag;
			}
		}
	}

	public checkIfUnsavedFlagExistfinalizeSprintMasterData() {
		let finalizeUnsaveFlag = false;
		for (let i = 0; i < this.finalizeSprintMasterData.length; i++) {
			if (this.finalizeSprintMasterData[i].isFinalizeSprintPageDirty) {
				finalizeUnsaveFlag = true;
			}
		}
		return finalizeUnsaveFlag;
	}
	openAboutPage(aboutScreenShow) {
		this.aboutScreen.next(aboutScreenShow);
	}

	openSpinner(): void {
		this.dialogRef = this.dialog.open(SpinnerComponent, {
			height: '74px',
			width: '74px',
			panelClass: 'custom-dialog-container'
		});
		this.dialogRef.afterOpened().subscribe(() => {
			timer(1000).pipe(take(1)).subscribe(() => {

			});
		})
	}

	closeSpinner() {
		this.dialogRef?.close();
	}


	downloadFile(downloadlink) {
		return this.http.get(`${downloadlink}`, {
			responseType: 'blob' as 'json',
			observe: 'response'
		}).subscribe(
			(data: any) => {
				const fileName = data.headers.get('content-disposition')
					.split(';')[1].split('filename')[1].split('=')[1].trim().split('"').join('');
				const type = data.headers.get('content-type');
				const blob = new Blob([data.body], { type });
				saveAs(blob, fileName);
			},
			err => {
				console.log(err);
			});
	}

	async downloadUserstories(downloadLink): Promise<boolean> {
		return new Promise((resolve) => {
			this.http.get(`${downloadLink}`, {
				responseType: 'blob' as 'json',
				observe: 'response'
			}).subscribe(
				(data: any) => {
					try {
						const contentDisposition = data.headers.get('content-disposition');
						let fileName = 'downloaded-file';
						if (contentDisposition) {
							const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
							if (matches != null && matches[1]) {
								fileName = matches[1].replace(/['"]/g, '');
							}
						}
						const type = data.headers.get('content-type');
						const blob = new Blob([data.body], { type });
						saveAs(blob, fileName);
						resolve(true);
					} catch (e) {
						console.log(e);
						resolve(false);
					}
				},
				err => {
					console.log(err);
					resolve(false);
				}
			);
		});
	}

	/**
	 * Security Fix: Use $batch API (POST) to keep PII in request body instead of URL
	 */
	getMsUserDetails(emailId: string) {
		const batchRequest = {
			requests: [{
				id: '1',
				method: 'GET',
				url: `/users?$filter=((startswith(displayName,'${emailId}') or startswith(userPrincipalName,'${emailId}')))`
			}]
		};
		
		return this.http.post(
			'https://graph.microsoft.com/v1.0/$batch',
			batchRequest
		).map((res: any) => {
			return res.responses?.[0]?.body?.value?.[0];
		});
	}

	getUserPermissionDataUpdated(): Observable<any> {
		return this.userPermissionDataUpdated.asObservable();
	}

	setExternalUserDataUpdated(data) {
		this.userPermissionDataUpdated.next(data);
	}

	getExternalUserData(pageName?) {
		let externalUserData = this.cryptUtilService.getItem("external-user-data", "SESSION");
		return pageName ? { isExternalUser: externalUserData?.isExternalUser, pages: externalUserData?.pages[pageName] } : externalUserData;
	}

	getHideNavigationBar(): Observable<any> {
		return this.hideNavigationBar.asObservable();
	}

	setHideNavigationBar(data) {
		this.hideNavigationBar.next(data);
	}

	getIsExternalSignupCompleted(): Observable<any> {
		return this.isExternalSignupCompleted.asObservable();
	}

	setIsExternalSignupCompleted(data) {
		this.isExternalSignupCompleted.next(data);
	}

	callUserRelatedAPI(): Observable<boolean> {
		return this.userRelatedAPI$.asObservable();
	}

	getDesignCompleteStatus(projectId) {
		return this.baseService.get(`/project/getStatus/isDesignComplete/${projectId}`, environment.API_MICROSERVICE_URL?.PROJECT);
	}
	getSourceMSTeamsSize(projectId: number)
	{

		return this.baseService.get(`/project/getSourceMSTeamsSize/${projectId}`, environment.API_MICROSERVICE_URL?.PROJECT);
	}

	/**
	* GetDownloadDocumentUrl: Method returns a
	* url of a document
	*
	* @returns string
	*/
	getDownloadDocumentUrl = () =>
		this.http.get(`${environment.API_MICROSERVICE_URL.ADMIN}/admin/get-user-manual-url`);

	getConfirmMsteamsData(projectId: number)
	{

		return this.baseService.get(`/project/getConfirmMsteamsData/${projectId}`, environment.API_MICROSERVICE_URL?.PROJECT);
	}

	getTargetSiteOwner(groupId: string)
	{
	  return this.baseService.get(`/project/getTargetSiteOwner/${groupId}`, environment.API_MICROSERVICE_URL?.PROJECT);
	}

	triggerUserRelatedAPI(data: boolean) {
		this.userRelatedAPI$.next(data);
	}

	getIsFeatureFlagUpdated(): Observable<any> {
		return this.isFeatureFlagUpdated.asObservable();
	}

	setIsFeatureFlagUpdated(data) {
		this.isFeatureFlagUpdated.next(data);
	}

	getFeatureConfiguration(property?) {
		const configurationObj = this.cryptUtilService.getItem("commonFeatureFlag", "LOCAL");
		return property ? configurationObj[property] : configurationObj;
	}

	setRedirectToPsg(data: boolean) {
		this.redirectToPsg.next(data);
	}

	getRedirectToPsg(): Observable<boolean> {
		return this.redirectToPsg.asObservable();
	}
	requestReportDownload(data?,url='/ReportsGeneration/RequestReport') {
		if (data != undefined)
			this.reportRequestPayload = data
		else
			data = this.reportRequestPayload
		this.reportRequestPayload.reportStatus = REPORT_GENERATION_STATUS.NEW_REPORT
		this.reportRequestPayload.reportFilters.ReportRequestId = 0
		return this.baseService.post(url, data,this.packageContentMicroservice)
	}

	lookForReport(reportRequestId: number) {
		const url = `${environment.API_MICROSERVICE_URL.REPORTING}/ReportsGeneration/ReportStatus/${reportRequestId}`;
		this.getReportRequestIdAndStatus(url)
		this.reportPollingTimer = setInterval(() => {
			this.getReportRequestIdAndStatus(url)
		}, 5000)
		return this.reportPollingTimer
	}
	downloadReport(reportRequestId: number) {
		let url: string = `${environment.API_MICROSERVICE_URL.REPORTING}/ReportsGeneration/Report`;
		url = url + `?reportrequestId=${reportRequestId ?? ''}`;
		var data = this.http.post(url, {}, {
			responseType: 'blob',
			observe: 'response'
		});

		data.subscribe(
			(data: any) => {
				const fileName = data.headers.get('Content-Disposition');
				const type = data.headers.get('Content-Type');
				const blob = new Blob([data.body], { type });
				saveAs(blob, fileName);
				this.globalContext.setNewReport({ active: true, status: 'COMPLETED' })
				this.deleteReportFromBlobRequest()
			},
			err => {
				this.globalContext.setNewReport({ active: true, status: 'ERROR' })
			});
	}
	getPackagesAndProjectStatuses() {
		return this.baseService.get(`/ReportsGeneration/ReportFilters`,this.packageContentMicroservice)
	}
	getPackagesAndProjectStatusesByReportId(reportId?: string) {
		const url = reportId ? `/ReportsGeneration/ReportFilters?reportId=${reportId}` : `/ReportsGeneration/ReportFilters`;
		return this.baseService.get(url, this.packageContentMicroservice);
	}
	/**
	 * Security Fix: Removed userId from URL path parameter - backend extracts user from JWT token
	 */
	getUserRole(userId, langId) {
		// userId parameter kept for compatibility but not used in URL - backend extracts from JWT
		return this.http.get<any>(`${environment.API_BASE_URL}/user-management/user-details?languageId=${langId}`)
	}
	getSupportedLanguages() {
		return this.http.get(`${environment.API_MICROSERVICE_URL.ADMIN}}/i18n/supportedLanguages`);
	}

	/**
	 * UpdateCrossRegionPreferredLanguage: Updates the preferred language for cross-region users.
	 *
	 * @param {String} url - The base URL for the API endpoint.
	 * @param {IUpdateCrossRegionLanguagePayload} body - The request payload containing the language preferences.
	 * @returns {Observable}
	 */
	updateCrossRegionPreferredLanguage = (
		url: string,
		body: IUpdateCrossRegionLanguagePayload
	  ): Observable<any> =>
		this.http.post(`${url}/user/api/v1/user-preferences/language`, body);

	updatePreferredLanguage(body) {
		return this.http.post(`${environment.API_MICROSERVICE_URL.USER}/user-preferences/language`, body);
	}

	getPreferredLanguage() {
		return this.http.get(`${environment.API_MICROSERVICE_URL.ADMIN}/i18n/languages`);
	}
	getReportRequestIdAndStatus(url: string) {
		const headers = new HttpHeaders().set('skip', 'true');
		this.http.get<any>(url, { headers})
			.subscribe(_ => {
				this.reportRequestId = _.requestID
				if (_.reportStatus == REPORT_STATUS_TYPE.READY_FOR_DOWNLAOD) {
					clearInterval(this.reportPollingTimer)
					this.downloadReport(_.requestID as number)
				}
				else if (_.reportStatus == REPORT_STATUS_TYPE.ERROR) {
					this.globalContext.setNewReport({ active: true, status: 'ERROR' })
					clearInterval(this.reportPollingTimer)
				}
			}, _ => {
				clearInterval(this.reportPollingTimer)
				this.globalContext.setNewReport({ active: true, status: 'ERROR' })
			})
	}
	cancelAndRetryReportGeneration(retryRequest = false) {
		clearInterval(this.reportPollingTimer)
		this.reportRequestPayload.reportFilters.ReportRequestId = this.reportRequestId
		if (retryRequest) {
			this.reportRequestPayload.reportStatus = REPORT_GENERATION_STATUS.RETRY
			this.baseService.post(`/ReportsGeneration/CancelorRetryRequest`, this.reportRequestPayload, this.packageContentMicroservice)
				.subscribe(_ => {
					this.lookForReport(this.reportRequestId)
				}, _ => {
					this.globalContext.setNewReport({ active: true, status: 'ERROR' })
				})
		}
		else {
			this.reportRequestPayload.reportStatus = REPORT_GENERATION_STATUS.CANCEL_REPORT
			this.baseService.post(`/ReportsGeneration/CancelorRetryRequest`, this.reportRequestPayload, this.packageContentMicroservice)
				.subscribe(_ => { })
		}
	}
	getOwenedTeamChannels() {
		return this.baseService.getWithoutLoader(`/project/get-owned-channels`,environment.API_MICROSERVICE_URL?.PROJECT)
	}
	postMsTeamsChannel(body) {
		return this.baseService.postWithRefreshToken(`/project/link-existing-channel`, body,environment.API_MICROSERVICE_URL?.PROJECT)

	}
	postMsTeamsSwapChannel(body) {

		return this.baseService.postWithRefreshToken(`/project/submit-msteams-swap`, body,environment.API_MICROSERVICE_URL?.PROJECT)

	}
	getConcurrentMsTeamsProvisonStatus(){
		return this.baseService.get(`/project/get-concurrent-ms-teams-provision-status`,environment.API_MICROSERVICE_URL?.PROJECT)
	}

	getTypesOfReports() {
		return this.baseService.get(`/ReportsGeneration/ReportTypes`, this.packageContentMicroservice)
	}

	deleteReportFromBlobRequest() {
		this.baseService.delete(`/ReportsGeneration/DeleteBlobFile/${this.reportRequestId}`, this.packageContentMicroservice)
			.subscribe(_ => { })
	}

	setUpdatedLangId(data) {
		this.languageFlag.next(data);
	}

	getUpdatedLangId(): Observable<any> {
		return this.languageFlag.asObservable();
	}

	setCurrentLanguage(data) {
		this.currentLangId.next(data);
	}

	getCurrentLanguage(): Observable<any> {
		const currentLangId = this.currentLangId.asObservable();
		currentLangId.subscribe((langId) => {
			if (!langId) {
				this.setCurrentLanguage(1);
			}
		});
		return this.currentLangId.asObservable();
	}

	getUserDetails() {
		return this.baseService.get(`/user/details`, environment.API_MICROSERVICE_URL?.USER)
	}

	getActiveFlag(): Observable<any> {
		return this.activeFlags.asObservable();
	}

	setActiveFlag(data) {
		this.activeFlags.next(data);
	}

	getFullPackageData()
	{
		return this.http.get(`${environment.API_MICROSERVICE_URL.METHOD}/package/getFiltersForDeliverablesReport`);
	}
	getToolsUtilizationReportFiltersData()
	{
		return this.http.get(`${environment.API_MICROSERVICE_URL.ADMIN}/tools/toolsUtilizationReport/filters`);
	}
	getTeamsDetails(project_id) {
		return this.baseService.get(`/project/get-teams/${project_id}`,environment.API_MICROSERVICE_URL?.PROJECT)
	}
	getTeamsStatusDetails(project_id) {
		return this.baseService.get(`/project/get-teams-status/${project_id}`,environment.API_MICROSERVICE_URL?.PROJECT)
	}
	setRoleChangeMessage(msg: string) {
    	this.roleChangeMessage.next(msg);
	}
	setUserRoleChange(msg: boolean) {
    	this.userRoleChange.next(msg);
	}
	getJIraEdcOrSaasUrl(jiraInstanceId: number, jiraProjectKey: string) {
    switch (jiraInstanceId) {
      case 1:
        return `${environment.JIRA_BASE_URL}/projects/${jiraProjectKey}/summary/statistics`;
      case 2:
        return `${environment.JIRA_SAAS_APP_BASE_URL}/jira/software/c/projects/${jiraProjectKey}/issues`;
      default:
        return '';
    }
  }

	/**
	 * GetTypesOfReportsForProjectSummary: This method is to fetch
	 * project summary report types
	 */
	getTypesOfReportsForProjectSummary = () =>  this.baseService.get(`/ReportsGeneration/ReportTypes/Project`, this.packageContentMicroservice)

	/**
	 * Fetches the release banner details from the server.
	 *
	 * @returns Observable
	 */
	getReleaseBannerDetails = () =>
		this.http.get(
		`${environment.API_MICROSERVICE_URL?.ADMIN}/tools/release-banner-details`
		);

	/**
	 * * getProjectSyncStatus : Fetches the Project sync status details from the server.
	 *
	 * @param projectId number
	 * @returns Observable
	 */
	getProjectSyncStatus = (projectId: number) =>
		this.http.get(
		`${environment.API_MICROSERVICE_URL.REPORTING}/ReportsGeneration/GetProjectSyncStatus/${projectId}`
		);

	/**
	 * * addConversionIntoTechnicalScope : This function will add conversion data to server.
	 *
	 * @param url string
	 * @param requestBody FormData | IConversionRequestBody
	 *
	 * @returns Observable
	 */
	addConversionIntoTechnicalScope = (url: string, requestBody:  FormData | IConversionRequestBody) =>
	  this.http.post(url, requestBody);

	/**
	 * DownloadDocument: Method Fetches a document from the
	 * specified URL as a Blob and download it.
	 *
	 * @param {String} url
	 * @returns Observable
	 */
	downloadDocument = (url: string) =>
		this.http.get(url, { responseType: "blob" });

	/**
	 * DownloadDocument: Method to upload document
	 *
	 * @param url string
	 * @param requestBody FormData | IRefineTaxonomyPayload
	 * @returns Observable
	 */
	uploadDocument = (url: string, requestBody: FormData | IRefineTaxonomyPayload) =>
	  this.http.post(url, requestBody, { responseType: "json" });

	/**
	 * DisplayNoDataMsg: Determines whether to display a "No Data" message based on the provided list data and API execution status.
	 *
	 * @param listData - An array of strings representing the list data.
	 * @param isApiExecuted - A boolean indicating whether the API has been executed.
	 * @returns A boolean value indicating whether to display the "No Data" message.
	 */
	displayNoDataMsg = (listData: string[], isApiExecuted: boolean): boolean => !listData?.length && isApiExecuted;

	/**
	 * EmitLanguageChange: Emits an event to notify subscribers about a language change.
	 * This method triggers the `next` method on the `languageChangeSubject`,
	 * which will notify all observers that a language change has occurred.
	 */
	emitLanguageChange = () => this.languageChangeSubject.next();
}
